<template>
  <v-layout justify-center>
    <div>
      <v-layout>
        <v-flex xm12 md4 offset-md4 class="text-sm-center">
          <span class="headline">ACCOUNTING</span><br />
        </v-flex>
        <v-flex xm12 sm4 class="title text-sm-right">
          <v-select
            v-model="emailTemplate"
            :items="emails"
            item-text="name"
            item-value="id"
            label="Email Template"
          ></v-select>
          <v-btn small value="email" color="primary" @click="buildEmail()" :disabled="!selected">
            Email Statements
          </v-btn>
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <vue-good-table
          ref="my-table"
          styleClass="vgt-table striped bordered"
          :max-height=this.height
          :fixed-header="true"
          :isLoading=this.isTableLoading
          :columns="columns"
          :rows="rows"
          :select-options="{
            enabled: true,
            selectOnCheckboxOnly: true
          }"
          :search-options="{
            enabled: true
          }">
          <template slot="loadingContent">
            <div>
              <v-progress-circular
                :size="50"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
          <div slot="table-actions-bottom">
            <v-layout align-center justify-start row fill-height>
              <v-flex xs12>
                <span style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
              </v-flex>
            </v-layout>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'email'">
              <v-layout align-center justify-start row fill-height>
                <v-flex xs12>
                  {{ props.row.VendorContacts[0].firstName }} {{ props.row.VendorContacts[0].lastName }}<br />
                  <a :href="'mailto:' + props.row.VendorContacts[0].email" style="text-decoration: none;">
                    {{ props.row.VendorContacts[0].email }}
                  </a>
                </v-flex>
              </v-layout>
            </span>
            <span v-else-if="props.column.field == 'invoiceDisplay'">
              <v-layout align-center justify-start row fill-height>
                <v-flex xs12 class="text-xs-right">
                  {{ props.row.invoiceDisplay }}
                </v-flex>
              </v-layout>
            </span>
            <span v-else-if="props.column.field == 'paymentDisplay'">
              <v-layout align-right justify-start row fill-height>
                <v-flex xs12 class="text-xs-right">
                  {{ props.row.paymentDisplay }}
                </v-flex>
              </v-layout>
            </span>
            <span v-else-if="props.column.field == 'balanceDisplay'">
              <v-layout align-center justify-start row fill-height>
                <v-flex xs12 v-if="props.row.balance < 0" class="text-xs-right red--text">{{ props.row.balanceDisplay }}</v-flex>
                <v-flex xs12 v-else class="text-xs-right">
                  {{ props.row.balanceDisplay }}
                </v-flex>
              </v-layout>
            </span>
            <span v-else-if="props.column.field == 'actions'">
              <div class="text-xs-center">
                <v-avatar
                  v-if="isCommChair"
                  color="blue lighten-4"
                  class="mr-2 mt-2"
                  size="30"
                  style="cursor: pointer;"
                  @click="editItem(props)"
                >
                  <v-icon small>edit</v-icon>
                </v-avatar>
              </div>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </v-flex>

      <InternalForm
        :visible="clientDialog"
        :item="editClient"
        :key="editClient.id"
        :memberList="memberList"
        :currentYear="currentYear"
        persistent
        @close="close"
      />

      <v-dialog v-model="dialog" max-width="500px">
        <v-card >
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="close">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Send Statements</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <template v-if="showBar">
              <v-progress-linear :indeterminate="true"></v-progress-linear>
            </template>
            <v-list>
              <v-list-tile
                v-for="item in sentStatements"
                :key="item"
              >
                <v-list-tile-content>
                  <v-list-tile-title v-text="item"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </div>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'

import InternalForm from './InternalForm.vue'

export default {
  props: ['visible', 'currentYear'],

  components: {
    VueGoodTable,
    InternalForm
  },

  data () {
    return {
      myId: this.$store.state.user.id,
      myName: this.$store.state.user.fullName,
      myEmail: this.$store.state.user.email,
      page: 'accounting',
      isAdmin: this.$store.state.isAdmin,
      isCommChair: false,
      dialog: false,
      clientDialog: false,
      showBar: false,
      isTableLoading: false,
      isMounted: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      height: 0,
      columns: [
        {
          label: 'Name',
          field: 'name',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Booth',
          field: 'booths',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Contact/Email',
          field: 'email',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Total',
          field: 'invoiceDisplay',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Payment',
          field: 'paymentDisplay',
          thClass: 'hidden-sm-and-down text-right',
          tdClass: 'hidden-sm-and-down text-right',
          type: 'text'
        },
        {
          label: 'Balance',
          field: 'balanceDisplay',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Action',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      newRows: [],
      rows: [],
      editClient: {},
      grandTotalInvoice: 0,
      grandTotalPayment: 0,
      grandTotalBalance: 0,
      grandTotalInvoiceDisplay: '',
      grandTotalPaymentDisplay: '',
      grandTotalBalanceDisplay: '',
      memberList: [],
      sentStatements: [],
      emails: [],
      emailTemplate: 0
    }
  },

  created () {
    this.isTableLoading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getMembers()
    this.getEmails()
    this.getVendors()

    this.isTableLoading = false
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    }
  },

  watch: {
    currentYear: {
      handler: function (val, oldVal) {
        this.getVendors()
      },
      deep: true
    }
  },

  methods: {
    async getMembers () {
      try {
        let item = {}
        let control = {}

        const controls = this.$store.state.controls
        control = controls.find(item => item === 'Vendor')
        console.log('control', control)

        console.log('controls', controls)

        if (control) {
          this.isCommChair = true
        } else if (this.isAdmin) {
          this.isCommChair = true
        } else {
          const response = await Api().get('get_committee_by_code/EXH/' + this.currentYear)
          this.memberList = response.data.committee.Users
          this.memberList.unshift({id: 0, fullName: 'None'})
          console.log(this.memberList)

          item = this.memberList.find(item => item.id === this.myId)

          if (item.UserCommittee.title === 'Chair' || item.UserCommittee.title === 'Assist Chair') {
            console.log('yes')
            this.isCommChair = true
          }

          console.log('item', this.isCommChair)
        }
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getEmails () {
      try {
        const response = await Api().get('email_templates/Vendor')
        this.emails = response.data
        // let email = {}

        // for (let i in emails) {
        //   email.value = emails[i].id
        //   email.name = emails[i].name

        //   this.emails.push(email)
        //   console.log(this.emails)
        // }
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 360
      this.height = height + 'px'
    },

    newItem () {
      this.dialog = true
    },

    editItem (props) {
      this.editClient = props.row

      this.clientDialog = true
    },

    async getVendors () {
      try {
        const response = await Api().get('vendors/' + this.currentYear)

        const vendorList = response.data

        let totalPayment = 0
        let totalInvoice = 0
        let grandTotalInvoice = 0
        let grandTotalPayment = 0
        let grandTotalBalance = 0

        for (let i in vendorList) {
          const accountingResponse = await Api().get('accounting/' + vendorList[i].id + '/' + this.currentYear)
          let accounting = accountingResponse.data
          console.log(vendorList[i].VendorDetails[0].category)

          let balance = 0
          let payment = 0
          let invoice = 0

          for (let j in accounting) {
            accounting[j].formattedDate = moment(accounting[j].date).format('MM/DD/YYYY')

            if (accounting[j].type === 'Payment' && accounting[j].status === 'Open') {
              if (accounting[j].paymentType !== 23) {
                payment = payment + Number(accounting[j].amount)
              }

              accounting[j].amount = Number(accounting[j].amount) * -1
              accounting[j].amountDisplay = accounting[j].amount.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
            } else if (accounting[j].status === 'Open') {
              let lineAmount = 0
              let invoiceAmount = 0

              for (let k in accounting[j].VendorAccountingDetails) {
                lineAmount = accounting[j].VendorAccountingDetails[k].quantity * Number(accounting[j].VendorAccountingDetails[k].price)
                invoiceAmount = invoiceAmount + lineAmount
              }

              invoice = invoice + invoiceAmount
              accounting[j].amount = invoiceAmount
              accounting[j].amountDisplay = invoiceAmount.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
            }
          }
          vendorList[i].accounting = accounting

          if (vendorList[i].VendorDetails[0].category === null || vendorList[i].VendorDetails[0].category === 'Vendor') {
            totalPayment = totalPayment + payment
            totalInvoice = totalInvoice + invoice
            balance = invoice - payment

            grandTotalPayment = grandTotalPayment + payment
            grandTotalInvoice = grandTotalInvoice + invoice
            grandTotalBalance = grandTotalBalance + balance
          }

          let booths = ''

          for (let j in vendorList[i].VendorBooths) {
            booths = booths + vendorList[i].VendorBooths[j].boothNumber + ' '
          }

          vendorList[i].payment = payment
          vendorList[i].paymentDisplay = payment.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
          vendorList[i].invoice = invoice
          vendorList[i].invoiceDisplay = invoice.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
          vendorList[i].balance = balance
          vendorList[i].balanceDisplay = balance.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
          vendorList[i].booths = booths
        }

        this.rows = this.newRows.concat(vendorList)

        this.grandTotalPayment = grandTotalPayment
        this.grandTotalPaymentDisplay = grandTotalPayment.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        this.grandTotalInvoice = grandTotalInvoice
        this.grandTotalInvoiceDisplay = grandTotalInvoice.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        this.grandTotalBalance = grandTotalBalance
        this.grandTotalBalanceDisplay = grandTotalBalance.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async buildEmail () {
      try {
        this.dialog = true
        this.showBar = true

        for (let i in this.$refs['my-table'].selectedRows) {
          let statement = {}

          statement.date = moment().format('MM/DD/YYYY')
          statement.saveDate = moment().format('YYYY-MM-DD')
          statement.item = this.$refs['my-table'].selectedRows[i]
          statement.rows = this.$refs['my-table'].selectedRows[i].accounting
          statement.emailTemplate = this.emailTemplate
          console.log(statement)

          const response = await Api().post('send_statement', statement)

          let notice = response.data.client + ' statement sent.'
          this.sentStatements.push(notice)
        }

        this.showBar = false

        this.snackbar.message = 'All statements sent.'
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      this.sentStatements = []

      this.dialog = false
      this.clientDialog = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/Accounting.vue